import React from 'react';
import calculateField from '../formBuilder/utility/calculateFields';
import { IoRemoveCircleOutline } from 'react-icons/io5';
import { FaRegCircleXmark } from 'react-icons/fa6';
import Tooltip from '../Tooltip';

export default function InvestmentMetric({ field, result }) {
  const { label, description } = field;

  const getIcon = (result) => {
    const { value } = result || {};

    switch (value) {
      case 0:
        return (
          <FaRegCircleXmark className="text-red-700 h-6 w-6 rounded-full" />
        );
      case 1:
        return (
          <svg height="24px" version="1.1" viewBox="0 0 20 20" width="24px">
            <title />
            <desc />
            <defs />
            <g
              fill="none"
              fillRule="evenodd"
              id="Page-1"
              stroke="none"
              strokeWidth="1"
            >
              <g
                fill="#15803D"
                id="Core"
                transform="translate(-128.000000, -86.000000)"
              >
                <g
                  id="check-circle-outline"
                  transform="translate(128.000000, 86.000000)"
                >
                  <path
                    d="M5.9,8.1 L4.5,9.5 L9,14 L19,4 L17.6,2.6 L9,11.2 L5.9,8.1 L5.9,8.1 Z M18,10 C18,14.4 14.4,18 10,18 C5.6,18 2,14.4 2,10 C2,5.6 5.6,2 10,2 C10.8,2 11.5,2.1 12.2,2.3 L13.8,0.7 C12.6,0.3 11.3,0 10,0 C4.5,0 0,4.5 0,10 C0,15.5 4.5,20 10,20 C15.5,20 20,15.5 20,10 L18,10 L18,10 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
          </svg>
        );
      case 2:
      default:
        return (
          <IoRemoveCircleOutline className="text-warning h-6 w-6 rounded-full" />
        );
    }
  };

  return (
    <div className="flex flex-col gap-1 justify-center items-center min-w-[100px]">
      <Tooltip text={result?.message || 'Error'} offset="-left-28 top-12">
        {getIcon(result)}
      </Tooltip>
      <h4 className="text-sm font-normal text-neutral-600 flex justify-center items-center gap-1">
        {!description && label}
        {description && (
          <Tooltip text={description} offset="-left-28 top-6">
            {label}
          </Tooltip>
        )}
      </h4>
    </div>
  );
}
